import { z } from 'zod';
/**
 * Generic image size variants produced at upload time. Each asset type (logo, avatar,
 * receipt) uses a subset; pixel dimensions are a backend processing concern and live in
 * the platform-api images constants.
 */
export const IMAGE_VARIANTS = ['sm', 'md', 'lg', 'xl', 'print'];
/** One of the generic image size variant names. */
export const ImageVariantSchema = z.enum(IMAGE_VARIANTS);
/**
 * Server-built map of variant name to URL. The server fills every key in the asset's
 * variant set — pointing multiple keys at one stored object where no distinct physical
 * variant exists — so clients index the variant they want without fallback logic.
 */
export const ImageVariantUrlsSchema = z.partialRecord(ImageVariantSchema, z.string());
//# sourceMappingURL=images.js.map